<script>
    import {createEventDispatcher} from "svelte";
    import EditableCell from "./EditableCell.svelte";
    import AuthService from '../services/auth.service.js';
    import ReportsService from "../services/reports.service";
    import { formatValue } from '../helpers/format.helper';
    import { onMount } from 'svelte';
    import { getValidMonthsForYTD, calculateTotal } from '../services/reports.service.js';

    export let params, headers, metrics, teams, selectedTeam, selectedActivity, searchText = '', roleFilter = null,
    localIndicatorFields = [], activityYTDValues = {}, teamMetrics = {};

    const PERCENT_FORMAT = 2;
    
    let metricsStates = {};
    let selectedMetric = {};
    let formattedTeamMetrics = {};

    onMount(() => {
        let metricsJSON = localStorage.getItem('metrics-toggle');
        metricsStates = metricsJSON ? JSON.parse(metricsJSON) : {};
    });

    function toggleMetric(metric) {
        metricsStates[metric.id] = !metricsStates[metric.id];

        localStorage.setItem('metrics-toggle', JSON.stringify(metricsStates));
        setTimeout(() => {
            enableTableSelection();
        }, 250);
    }

    function editMetricNotes(team, metric) {
        selectedMetric = {
            title: metric.title,
            id: metric.id,
            team_id: team.id,
            notes: formattedTeamMetrics[team.id][metric.id].notes
        };
        jQuery('#metricNotesModal').modal('show');
    }

    async function saveMetricNotes() {
        dispatch('saveMetricNotes', selectedMetric);
        jQuery('#metricNotesModal').modal('hide');
        selectedMetric = {};
    }

    function getDateKeyFromHeader(header) {
        const [month, year] = header.split('/');
        const monthMap = {
            'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04', 'May': '05', 'Jun': '06',
            'Jul': '07', 'Aug': '08', 'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
        };
        return `${year}-${monthMap[month]}-01`;
    }

    function calculateRowTotal(employees, metric, header, field) {
        if (!employees || !employees.length) return 0;

        const dateKey = getDateKeyFromHeader(header);
        const IS_PERCENT_FORMAT = metric.format === PERCENT_FORMAT;
        let averageValidValues = 0;

        let total = 0;
        employees.forEach(emp => {
            const metricData = emp.metrics? emp.metrics.find(m => m.id === metric.id): [];
            if (metricData && metricData.data && metricData.data[dateKey]) {
                const value = metricData.data[dateKey][field];
                const budgetValue = metricData.data[dateKey]['budget'];

                if (value !== undefined && value !== null && value !== '') {
                    const numValue = parseFloat(value, 10);
                    if (!isNaN(numValue)) {
                        total += numValue;
                        // count only valid percent values with budget or value > 0
                        if (IS_PERCENT_FORMAT && (budgetValue || numValue > 0)) {
                            averageValidValues++;
                        }
                    }
                }
            }
        });
        
        if (IS_PERCENT_FORMAT) {
            if (averageValidValues > 0) {
                return total / averageValidValues;
            }
            return 0;
        }
        return total;
    }

    function formatNumber(value) {
        return isNaN(value) ? '0' : Math.round(value).toString();
    }

    let loading = false;

    const dispatch = createEventDispatcher();

    function editEmployee(e, employee, team) {
        e.stopPropagation();
        dispatch('editEmployee', {
            employee: employee,
            team: team
        });
    }

    function editMetric(e, metric) {
        e.stopPropagation();
        dispatch('editMetric', metric);
    }

    async function saveActivity(actual, budget, metric_id, employee_id, date, valueType, teamId, elementId) {
        const newDate = new Date(date || '');

        const payload = {
            employee_id,
            metric_id,
            date: newDate,
        };

        if (valueType === 'actual') {
            payload.actual = actual;
        } else {
            payload.budget = budget;
        }
        
        await ReportsService.saveEmployeeActivity(payload);
        jQuery('#'+elementId).addClass('manual-data-kpi');

        localIndicatorFields.push({
            team_id: teamId,
            employee_id,
            metric_id,
            date,
            field: valueType
        });

        const metric = metrics.find(m => m.id === metric_id);
        const team = teams.find(t => t.id === teamId);
        const employee = team && team.employees ? team.employees.find(emp => emp.id === employee_id) : null;
        const metricData = employee && employee.metrics ? employee.metrics.find(m => m.id === metric_id) : null;

        if (metric && metricData) {
            calculateEmployeeMetricYTD(employee_id, metric_id, metric, metricData);
            calculateTotalYTDs(metric, team);
            activityYTDValues = activityYTDValues;
        }
    }

    function fillEmployee(team) {
        dispatch('fillEmployee', team);
    }

    $: if (roleFilter !== false) {
        teams = teams;
    }

    function isTeamEmpty(team) {
        if (roleFilter && team && roleFilter.id !== team.id) return true;

        const teamEmployees = team.employees || [];
        const isEmpty = teamEmployees.filter((emp) => emp.metrics && emp.metrics.length > 0).length === 0;
        return isEmpty;
    }

    function employeeHasMetric(employee, metric) {
        const result = employee.metrics && employee.metrics.filter((m) => m.id === metric.id).length > 0;
        return result;
    }

    function getEmployeeMetrics(employee, metricID) {
        let filtered = employee.metrics.filter((m) => m.id === metricID) || [];

        if (filtered.length > 0) {
            // truncate to 12 rows
            filtered = filtered.slice(0, 12);
        }

        return filtered;
    }

    function teamHasMetric(team, metric) {
        const result = team.employees && team.employees.filter((emp) => employeeHasMetric(emp, metric)).length > 0;
        if (result) {
            const teamMetric = teamMetrics[team.id];
            if (teamMetric) {
                const metricData = teamMetric.find(tm => tm.metric_id === metric.id);
                if (metricData) {
                    formattedTeamMetrics[team.id][metric.id] = {
                        notes: metricData.notes
                    }
                }
            }
        }
        return result;
    }

    function selectRole(team) {
        dispatch('selectRole', team);
    }

    function calculateRowIndex(employee, currentMetricIndex) {
        let rowCount = 0;
        for (let i = 0; i < currentMetricIndex; i++) {
            if (employee.metrics[i] && employee.metrics[i].show_budget) {
                rowCount += 2; // if the metric has budget, count as 2 rows
            } else {
                rowCount += 1;
            }
        }
        return rowCount;
    }

    function calculateMetricRowIndex(team, metricId, employeeIndex) {
        let rowCount = 0;

        for (let i = 0; i < employeeIndex; i++) {
            const emp = team.employees[i];
            if (!emp) continue;

            const hasMetric = emp.metrics && emp.metrics.some(m => m.id === metricId);

            if (hasMetric) {
                const metricData = emp.metrics.find(m => m.id === metricId);
                if (metricData && metricData.show_budget) {
                    rowCount += 2;
                } else {
                    rowCount += 1;
                }
            }
        }

        return rowCount;
    }

    const showMetricBudget =(employee, metricId) => {
        const metric = employee.metrics.find(m => m.id === metricId);
        return metric && metric.show_budget;
    }

    function getClass(data, date, isValid) {
        const today = new Date();
        let newDate = new Date(date);

        if (data === null) {
            const dateParts = date.split('/');
            const month = dateParts[0];
            const year = dateParts[1] || today.getFullYear();
            newDate = new Date(`01-${month}-${year}`);

            if (newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth()) return '';
            if (newDate.getTime() >= today.getTime()) return '';
            return 'style-'+(isValid === true? 'green' : 'red');
        }

        // if newDate is this year's month return empty string
        if ((newDate.getFullYear() === today.getFullYear() && newDate.getMonth() === today.getMonth() - 1) ||
            (newDate.getTime() >= today.getTime())) return;

        let className = 'style-' + (!data || (data.actual >= data.budget) ? 'green' : 'red');

        if (!data.actual_imported) {
            className += ' manual-data-kpi';
        }

        return className;
    }


    function recalculateYTDs() {
        activityYTDValues = {};
        
        teams.forEach(team => {
            if (!team.employees) return;
            team.employees.forEach(employee => {
                if (!employee.metrics) return;
                activityYTDValues[employee.id] = activityYTDValues[employee.id] || {};
                metrics.forEach(metric => {
                    const metricData = employee.metrics.find(m => m.id === metric.id);
                    if (!metricData || !metricData.data) return;
                    
                    calculateEmployeeMetricYTD(employee.id, metric.id, metric, metricData);
                });
            });

            metrics.forEach(metric => {
                calculateTotalYTDs(metric, team);
            });
        });
    }

    function calculateEmployeeMetricYTD(employeeId, metricId, metric, metricData) {
        const validHeaders = getValidMonthsForYTD(headers, params.year, 'YTD');
        const validDateKeys = validHeaders.map(header => getDateKeyFromHeader(header));
        
        let actualValues = validDateKeys.map(dateKey => {
            if (metricData.data && metricData.data[dateKey] && metricData.data[dateKey].actual != null) {
                return metricData.data[dateKey].actual;
            }
            return null;
        });
        let budgetValues = validDateKeys.map(dateKey => {
            if (metricData.data && metricData.data[dateKey] && metricData.data[dateKey].budget != null) {
                return metricData.data[dateKey].budget;
            }
            return null;
        });
        if ((metric.ytd_formula) === 'AVG') {
            actualValues = actualValues.filter(v => v > 0);
            budgetValues = budgetValues.filter(v => v > 0);
        }
        activityYTDValues[employeeId] = activityYTDValues[employeeId] || {};
        activityYTDValues[employeeId][metricId] = activityYTDValues[employeeId][metricId] || {};
        activityYTDValues[employeeId][metricId].actual = calculateTotal(actualValues, metric.ytd_formula || 'SUM');
        activityYTDValues[employeeId][metricId].budget = calculateTotal(budgetValues, metric.ytd_formula || 'SUM');
    }

    function calculateTotalYTDs(metric, team) {
        activityYTDValues['total'] = activityYTDValues['total'] || {};
        activityYTDValues['total'][team.id] = activityYTDValues['total'][team.id] || {};

        let actuals = [];
        let budgets = [];

        if (!team.employees) return;
        team.employees.forEach(employee => {
            if (activityYTDValues[employee.id] && activityYTDValues[employee.id][metric.id]) {
                const employeeYTD = activityYTDValues[employee.id][metric.id];
                if (employeeYTD.actual != null && !isNaN(employeeYTD.actual) && employeeYTD.actual > 0) {
                    actuals.push(employeeYTD.actual);
                }
                if (employeeYTD.budget != null && !isNaN(employeeYTD.budget) && employeeYTD.budget > 0) {
                    budgets.push(employeeYTD.budget);
                }
            }
        });

        if (metric.format === PERCENT_FORMAT && actuals.length > 0) {
            activityYTDValues['total'][team.id][metric.id] = {
                actual: actuals.reduce((a, b) => a + b, 0) / actuals.length,
                budget: budgets.length > 0 ? budgets.reduce((a, b) => a + b, 0) / budgets.length : 0
            };
        } else {
            activityYTDValues['total'][team.id][metric.id] = {
                actual: actuals.reduce((a, b) => a + b, 0),
                budget: budgets.reduce((a, b) => a + b, 0)
            };
        }
    }

    const resetTeamMetrics = () => {
        formattedTeamMetrics = {};
        teams.forEach(team => {
            formattedTeamMetrics[team.id] = {};
        });
    }

    $: if (teams && metrics && headers && params) {
        recalculateYTDs();
    }

    $: if (metrics) {
        resetTeamMetrics();
        recalculateYTDs();
    }
</script>

{#each teams as team, teamIndex}
    {#if !isTeamEmpty(team)}
        <div class="table-wrapper pt-3 { selectedTeam && selectedTeam == team.id ? 'selectedSection' : ''}">
            <h4>
                {team.title}
                {#if team.notes && team.notes.length > 0}
                    <i data-notes="{team.notes}"
                       class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                {/if}
                <small class="px-1" on:click={ (e) => selectRole(team) }>
                    <i data-id="{team.id}"
                       class="fa fa-pencil-square-o text-primary btn btn-sm px-0 action-edit"></i>
                </small>
            </h4>
            {#if selectedActivity === 'employee'}
                {#each team.employees as employee, employeeIndex}
                    {#if !searchText || employee.name.toLowerCase().indexOf(searchText) >= 0}
                        {#if employee && employee.metrics && employee.metrics.length > 0}
                            <table class="table table-sm container-fluid table-weekly selectable-table">
                                <thead>
                                    <tr class="bg-dark text-light">
                                        <th class="col-header">
                                            {employee.name} - {employee.start_date_formatted || ''}
                                            {#if AuthService.can('EDIT_EMPLOYEE') }
                                                <i data-id="{employee.id}"
                                                on:click={ (e) => editEmployee(e, employee, team) }
                                                class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                                            {/if}
                                        </th>
                                        <th class="col-subheader subheader-date">Type</th>

                                        {#each headers as header}
                                            {#if header != 'rank'}
                                                <th class="notFixed">
                                                    {header}
                                                </th>
                                            {/if}
                                        {/each}
                                    </tr>
                                </thead>
                                <tbody>
                                    {#each employee.metrics as metric, metricIndex}
                                        {#if metric && metric.data && Object.keys(metric.data).length > 0}
                                            <tr>
                                                <th class="col-header">
                                                    {metric.title}
                                                </th>
                                                <td class="col-info">
                                                    ACTUAL
                                                    {#if metric.show_budget}
                                                        <div style="border-top: 1px solid #dee2e6 !important;">
                                                            BUDGET
                                                        </div>
                                                    {/if}
                                                </td>
                                                {#each Object.keys(metric.data) as id, employeDataIndex}
                                                    <td class="notFixed p-0">
                                                        <EditableCell
                                                            id="t{employeeIndex}-{calculateRowIndex(employee, metricIndex)}-{employeDataIndex}"
                                                            xdata="{ {metric: metric.id, employee: employee.id, report: 'employee', date: id, field: 'actual', value: metric.data[id].actual } }"
                                                            on:change={(e) => saveActivity(e.detail.value, metric.data[id].budget, metric.id, employee.id, id, 'actual', team.id, `t${employeeIndex}-${calculateRowIndex(employee, metricIndex)}-${employeDataIndex}`)}
                                                            bind:value={metric.data[id].actual}
                                                            customClass="{getClass(metric.data[id], id)}"
                                                            format={metric.format}></EditableCell>
                                                            {#if metric.show_budget}
                                                                <div style="border-top: 1px solid #dee2e6 !important;">
                                                                    <EditableCell
                                                                        id="t{employeeIndex}-{calculateRowIndex(employee, metricIndex) + 1}-{employeDataIndex}"
                                                                        customClass="{(!metric.data[id].budget_imported)?'manual-data-kpi':''}"
                                                                        xdata="{ {metric: metric.id, employee: employee.id, report: 'employee', date: id, field: 'budget', value: metric.data[id].budget } }"
                                                                        on:change={(e) => saveActivity(metric.data[id].actual, e.detail.value, metric.id, employee.id, id, 'budget', team.id, `t${employeeIndex}-${calculateRowIndex(employee, metricIndex) + 1}-${employeDataIndex}`)}
                                                                        bind:value={metric.data[id].budget}
                                                                        format={metric.format}></EditableCell>
                                                                </div>
                                                            {/if}
                                                        </td>
                                                {/each}
                                            </tr>
                                        {/if}
                                    {/each}
                                    <tr><td>&nbsp;</td></tr>
                                </tbody>
                            </table>
                        {/if}
                    {/if}
                {/each}
            {:else}
                {#each metrics as metric, metricIndex}
                    {#if teamHasMetric(team, metric) && (!searchText || metric.title.toLowerCase().indexOf(searchText) >= 0)}
                        <table class="table table-sm container-fluid table-weekly selectable-table collapsable">
                            <thead>
                            <tr class="bg-dark text-light">
                                <th class="col-header">
                                    <i on:click={ () => toggleMetric(metric)}
                                       class="mr-1 fa fa-{ metricsStates[metric.id] ? 'minus': 'plus' }-square text-light btn btn-sm px-0"></i>
                                    {metric.title}
                                    {#if formattedTeamMetrics[team.id] && formattedTeamMetrics[team.id][metric.id] && formattedTeamMetrics[team.id][metric.id].notes}
                                        <i data-notes="{formattedTeamMetrics[team.id][metric.id].notes}"
                                        class="fa fa-sticky-note-o fa-corner-icon float-right btn btn-sm px-0 action-comment"></i>
                                    {/if}
                                    {#if AuthService.can('EDIT_EMPLOYEE')}
                                        <i on:click={ (e) => editMetricNotes(team, metric) }
                                           class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                                    {/if}
                                </th>
                                <th class="col-subheader subheader-date">Start Date</th>
                                <th class="col-subheader subheader-date">Type</th>
                                <th class="notFixed">YTD</th>
                                {#each headers as header}
                                    {#if header != 'rank'}
                                        <th class="notFixed">
                                            {header}
                                        </th>
                                    {/if}
                                {/each}
                            </tr>
                            </thead>
                            <tbody>
                            {#if metricsStates[metric.id]}
                                {#each team.employees as employee, employeeIndex}
                                    {#if employeeHasMetric(employee, metric)}
                                        <tr>
                                            <th class="col-header">
                                                {employee.name}
                                                {#if AuthService.can('EDIT_EMPLOYEE') }
                                                    <i data-id="{employee.id}"
                                                    on:click={ (e) => editEmployee(e, employee, team) }
                                                    class="fa fa-pencil-square-o text-primary float-right btn btn-sm px-0 action-edit"></i>
                                                {/if}
                                            </th>
                                            <td class="col-subheader">{employee.start_date_formatted || ''}</td>
                                            <td class="col-info">
                                                ACTUAL
                                                {#if showMetricBudget(employee, metric.id)}
                                                    <div style="border-top: 1px solid #dee2e6 !important;">
                                                        BUDGET
                                                    </div>
                                                {/if}
                                            </td>
                                            <td class="notFixed">
                                                <div class="readOnly {activityYTDValues[employee.id][metric.id].actual >= activityYTDValues[employee.id][metric.id].budget ? 'style-green' : 'style-red'}">
                                                    {formatValue(metric.format, activityYTDValues[employee.id][metric.id].actual || 0)}
                                                </div>
                                                {#if showMetricBudget(employee, metric.id)}
                                                    <div style="border-top: 1px solid #dee2e6 !important;" class="readOnly">
                                                        {formatValue(metric.format, activityYTDValues[employee.id][metric.id].budget || 0)}
                                                    </div>
                                                {/if}
                                            </td>
                                            {#if employee.metrics && employee.metrics.length > 0}
                                                {#each getEmployeeMetrics(employee, metric.id) as metricData, metricDataIndex}
                                                    {#if metricDataIndex === 0}
                                                        {#each Object.keys(metricData.data) as id, employeDataIndex}
                                                            <td class="notFixed p-0">
                                                                <EditableCell
                                                                    id="t{metricIndex}-{calculateMetricRowIndex(team, metric.id, employeeIndex)}-{employeDataIndex}"
                                                                    xdata="{ {id: metricData.id, employee: employee.id, metric: metricData.id, report: 'employee', date: id, field: 'actual', value: metricData.data[id].actual } }"
                                                                    on:change={(e) => saveActivity(e.detail.value, metricData.data[id].budget, metricData.id, employee.id, id, 'actual', team.id, `t${metricIndex}-${calculateMetricRowIndex(team, metric.id, employeeIndex)}-${employeDataIndex}`) && (headers = headers)}
                                                                    bind:value={metricData.data[id].actual}
                                                                    customClass="{getClass(metricData.data[id], id)}"
                                                                    format={metric.format}></EditableCell>
                                                                {#if metricData.show_budget}
                                                                    <div style="border-top: 1px solid #dee2e6 !important;">
                                                                        <EditableCell
                                                                            id="t{metricIndex}-{calculateMetricRowIndex(team, metric.id, employeeIndex) + 1}-{employeDataIndex}"
                                                                            customClass="{(!metricData.data[id].budget_imported)?'manual-data-kpi':''}"
                                                                            xdata="{ {id: metricData.id, employee: employee.id, metric: metricData.id, report: 'employee', date: id, field: 'budget', value: metricData.data[id].budget } }"
                                                                            on:change={(e) => saveActivity(metricData.data[id].actual, e.detail.value, metricData.id, employee.id, id, 'budget', team.id, `t${metricIndex}-${calculateMetricRowIndex(team, metric.id, employeeIndex) + 1}-${employeDataIndex}`) && (headers = headers)}
                                                                            bind:value={metricData.data[id].budget}
                                                                                format={metric.format}></EditableCell>
                                                                    </div>
                                                                {/if}
                                                            </td>
                                                        {/each}
                                                    {/if}
                                                {/each}
                                            {/if}
                                        </tr>
                                    {/if}
                                {/each}
                            {/if}
                            <tr class="border-top">
                                <td class="font-weight-bold notFixed readOnly rank text-left">Total</td>
                                <td class="notFixed readOnly rank"></td>
                                <td class="notFixed readOnly rank"></td>
                                <td class="notFixed readOnly rank">
                                    <div class="readOnly {activityYTDValues['total'] && activityYTDValues['total'][team.id] && activityYTDValues['total'][team.id][metric.id] && activityYTDValues['total'][team.id][metric.id].actual >= activityYTDValues['total'][team.id][metric.id].budget ? 'style-green' : 'style-red'}">
                                        {formatValue(metric.format, activityYTDValues['total'] && activityYTDValues['total'][team.id] && activityYTDValues['total'][team.id][metric.id] ? activityYTDValues['total'][team.id][metric.id].actual || 0 : 0)}
                                    </div>
                                </td>
                                {#each headers.filter(h => h !== 'rank') as header}
                                    <td class="{getClass(null, header, calculateRowTotal(team.employees, metric, header, 'actual') >= calculateRowTotal(team.employees, metric, header, 'budget'))}">
                                        {formatValue(metric.format, formatNumber(calculateRowTotal(team.employees, metric, header, 'actual')))}
                                    </td>
                                {/each}
                            </tr>
                            {#if metric.show_budget}
                                <tr class="border-top">
                                    <td class="font-weight-bold notFixed readOnly rank text-left">Target</td>
                                    <td class="notFixed readOnly rank"></td>
                                    <td class="notFixed readOnly rank"></td>
                                    <td class="notFixed readOnly rank">
                                        {formatValue(metric.format, activityYTDValues['total'] && activityYTDValues['total'][team.id] && activityYTDValues['total'][team.id][metric.id] ? activityYTDValues['total'][team.id][metric.id].budget || 0 : 0)}
                                    </td>
                                    {#each headers.filter(h => h !== 'rank') as header}
                                        <td>
                                            <div class="mt-1">
                                                {formatValue(metric.format, formatNumber(calculateRowTotal(team.employees, metric, header, 'budget')))}
                                            </div>
                                        </td>
                                    {/each}
                                </tr>
                            {/if}
                            <tr><td>&nbsp;</td></tr>
                            </tbody>
                        </table>
                    {/if}
                {/each}
            {/if}
        </div>
    {/if}
{/each}

<div class="modal fade" id="metricNotesModal" tabindex="-1" role="dialog" aria-labelledby="metricNotesModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="metricNotesModalLabel">
                    {#if selectedMetric}
                        <em class="text-dark bg-warning px-1">{selectedMetric.title}</em>
                    {:else}
                        New
                    {/if}
                    Metric Notes
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" on:click={() => jQuery('#metricNotesModal').modal('hide')}>
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body text-left">
                <div class="form-group">
                    <label for="metricNotesInput">Notes</label>
                    <textarea bind:value={selectedMetric.notes} type="text" class="form-control"
                            id="metricNotesInput" placeholder="Notes for this metric" rows="8"></textarea>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={() => jQuery('#metricNotesModal').modal('hide')}>Close</button>
                <button type="button" class="btn btn-success" on:click={saveMetricNotes}>
                    Save
                </button>
            </div>
        </div>
    </div>
</div>